import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { Tooltip } from 'react-wot-bootstrap'

import {
    UPGRADE_EFFECT_TOOLTIP_ID,
    TOOLTIP_BODY,
    MODERNIZATION_BUTTON_TITLE,
} from './constants.jsx'
import styles from './UpgradeEffect.scss'

export const UpgradeEffect = (props) => {
    let tooltip
    // if same tooltip already exists - skip
    const sameTooltipExists = Tooltip.manager.tooltips.has(UPGRADE_EFFECT_TOOLTIP_ID)
    if (!sameTooltipExists){
        tooltip = (
            <Tooltip id={UPGRADE_EFFECT_TOOLTIP_ID}>
                <div className={styles.tooltipContent}>
                    <h3 className={styles.tooltipSubtitle}>{MODERNIZATION_BUTTON_TITLE}</h3>
                    <p className={styles.tooltipMessage}>{TOOLTIP_BODY}</p>
                </div>
            </Tooltip>
        )
    }

    const className = classNames(styles.base, {
        [styles.base__underCost]: props.hasPermission && !props.topLevel || props.fade,
        [styles.base__fade]: props.fade,
    })

    return (
        <div className={className}>
            <div className={styles.holder} data-tip data-for={UPGRADE_EFFECT_TOOLTIP_ID}>
                <div
                    className={styles.inner}
                    onClick={props.handleClick}
                    onMouseEnter={props.handleHover}
                >
                    <span className={styles.info}></span>
                    <span className={styles.title}>
                        {MODERNIZATION_BUTTON_TITLE}
                    </span>
                </div>
            </div>
            {tooltip}
        </div>
    )
}

UpgradeEffect.propTypes = {
    handleClick: PropTypes.func,
    handleHover: PropTypes.func,
    hasPermission: PropTypes.bool.isRequired,
    fade: PropTypes.bool.isRequired,
    topLevel: PropTypes.bool,
}

export default UpgradeEffect



// WEBPACK FOOTER //
// ./components/UpgradeEffect/UpgradeEffect.jsx